import { createStyles, Theme, withStyles } from '@material-ui/core';
import { container, cardTitle } from '../wisene-material-dashboard-pro-react-types';

const loginPageStyle = withStyles((theme: Theme) =>
	createStyles({
		container: {
			...container,
			zIndex: 4,
			[theme.breakpoints.down('sm')]: {
				paddingBottom: '100px',
			},
		},
		cardTitle: {
			...cardTitle,
			color: '#FFFFFF',
		},
		textCenter: {
			textAlign: 'center',
		},
		justifyContentCenter: {
			justifyContent: 'center !important',
			flexDirection: 'column',
			color: 'rgb(90, 90, 90)'
		},
		customButtonClass: {
			'&,&:focus,&:hover': {
				color: '#FFFFFF',
			},
			marginLeft: '5px',
			marginRight: '5px',
		},
		inputAdornment: {
			marginRight: '18px',
		},
		inputAdornmentIcon: {
			color: '#555',
		},
		cardHidden: {
			opacity: '0',
			transform: 'translate3d(0, -60px, 0)',
		},
		cardHeader: {
			marginBottom: '20px',
		},
		socialLine: {
			padding: '0.9375rem 0',
		},
		loginIcon: {
			height: '50px',
			transform: 'translationY(2px)',
			color: 'black',
		},
	})
);

export default loginPageStyle;
